module.exports = __webpack_public_path__ + "img/black.46658426.jpg";